import api from "./api";

// Capa de servicios API del dominio "cola" (FSD / D8.1.3).
// Wrappers de transporte finos: la construcción de payloads/params vive en el
// componente; aquí solo se centraliza el endpoint (un único lugar que tocar si cambia).

// --- Cola ---
export const findAllQueues = (params) => api.get("/queue", { params });
export const findQueueById = (queueId) => api.get(`/queue/${queueId}`);
export const createQueue = (payload) => api.post("/queue", payload);
export const updateQueue = (queueId, payload) => api.put(`/queue/${queueId}`, payload);
export const deleteQueue = (queueId) => api.delete(`/queue/${queueId}`);
export const checkQueueAI = (queueId) => api.get(`/queue/${queueId}/check-ai`);

// --- Media de la cola ---
export const uploadQueueMedia = (queueId, formData) =>
  api.post(`/queue/${queueId}/media-upload`, formData);
export const deleteQueueMedia = (queueId) => api.delete(`/queue/${queueId}/media-upload`);

// --- Cambios de configuración (preview / apply) ---
export const previewQueueChange = (queueId, payload) =>
  api.post(`/queue/${queueId}/preview-change`, payload);
export const applyQueueChange = (queueId, payload) =>
  api.post(`/queue/${queueId}/apply-change`, payload);

// --- Palabras clave (grupos de keywords) ---
export const findQueueKeywords = (queueId) => api.get(`/queue/${queueId}/keywords`);
export const createQueueKeyword = (queueId, groupData) =>
  api.post(`/queue/${queueId}/keywords`, groupData);
export const updateQueueKeyword = (queueId, groupId, groupData) =>
  api.put(`/queue/${queueId}/keywords/${groupId}`, groupData);
export const deleteQueueKeyword = (queueId, groupId) =>
  api.delete(`/queue/${queueId}/keywords/${groupId}`);

// --- Lookups cross-domain usados por el modal (consolidar en D8.5) ---
export const findPrompts = () => api.get("/prompt");
export const validatePromptApi = (payload) => api.post("/prompt/validate-api", payload);
export const findSettings = () => api.get("/settings");
export const findQueueIntegrations = () => api.get("/queueIntegration");
export const findFlowBuilders = (params) => api.get("/flowbuilders", { params });
export const findWhatsapps = (params) => api.get("/whatsapp", { params });
